export default {
  prisbasBelopp: 57300,
  prisBasBeloppProcentsats: 0.29,
  ranteProcent: parseFloat((0.7 * 2.62 + 1).toFixed(3)) / 100,
  fordonsSkatt: 360,
  prisDelProcent: 13 / 100,
  schablonAvdragEl: 350000,
  schablonAvdragLaddHybrid: 140000,
  brytpunkt: 615300,
  arbetsgivaravgiftProcent: 0.3142,
};
